var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5714 1H17.7143C18.4244 1 19 1.57563 19 2.28571V7.42857C19 8.13865 18.4244 8.71429 17.7143 8.71429H12.5714C11.8613 8.71429 11.2857 8.13865 11.2857 7.42857V2.28571C11.2857 1.57563 11.8613 1 12.5714 1ZM2.28571 1H7.42857C8.13865 1 8.71429 1.57563 8.71429 2.28571V7.42857C8.71429 8.13865 8.13865 8.71429 7.42857 8.71429H2.28571C1.57563 8.71429 1 8.13865 1 7.42857V2.28571C1 1.57563 1.57563 1 2.28571 1ZM12.5714 11.2857H17.7143C18.4244 11.2857 19 11.8613 19 12.5714V17.7143C19 18.4244 18.4244 19 17.7143 19H12.5714C11.8613 19 11.2857 18.4244 11.2857 17.7143V12.5714C11.2857 11.8613 11.8613 11.2857 12.5714 11.2857ZM2.28571 11.2857H7.42857C8.13865 11.2857 8.71429 11.8613 8.71429 12.5714V17.7143C8.71429 18.4244 8.13865 19 7.42857 19H2.28571C1.57563 19 1 18.4244 1 17.7143V12.5714C1 11.8613 1.57563 11.2857 2.28571 11.2857Z",
    stroke: "#696f7a",
    strokeWidth: 1.4625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overviewIcon.3d278fe82f59f9dc32790c72032498f3.svg";
export { ForwardRef as ReactComponent };